import { Props_SnippetContent } from './Content.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetContent = (props: Props_SnippetContent) => {
    const { snippet, heading, repeatable_link, paragraph, linkProps, image } = props

    const classSnippetBackgroundColor: string = snippet?.backgroundColor?.value ? `snippet-content--background-${snippet.backgroundColor?.value}` : ''
    const classHeadingVisibility: string = heading?.visibility?.value ? 'snippet-content__heading--visible' : 'snippet-content__heading--hidden'
    const linkAlignmentClass: string = linkProps?.alignment?.value ? `snippet-content__link-container--${linkProps.alignment.value}` : ''

    return (
        <section className={`snippet-content ${classSnippetBackgroundColor}`}>
            <div className="snippet-content__container">
                <h2 className={`snippet-content__heading ${classHeadingVisibility}`}>
                    {heading.content.value!}
                </h2>
                <div className="snippet-content__content">
                    {paragraph.text.value && CompileMarkdown(paragraph?.text?.value)}
                </div>
                <div className={`snippet-content__link-container ${linkAlignmentClass}`}>
                    {repeatable_link.map(({ linkHref, linkTarget, linkText, linkStyle, linkAriaLabel }, index) => (
                        <SnippetLink
                            key={`link-${linkHref} ${index}`}
                            linkStyles={linkStyle?.value}
                            className="snippet-content__link"
                            url={linkHref?.value}
                            openInNewTab={linkTarget?.value}
                            aria-label={linkAriaLabel?.value || linkText?.value}
                        >
                            {linkText?.value}
                        </SnippetLink>
                    ))}
                </div>
            </div>
            {image?.src?.value && (
                <img
                    className="snippet-content__background-image"
                    loading="lazy"
                    src={image.src.value}
                    alt={image.alt?.value || ''}
                />
            )}
        </section>
    )
}

export default SnippetContent
